"use strict";exports.__esModule = true;exports.default = void 0;var _makeupRovingTabindex = require("makeup-roving-tabindex");
var eventUtils = _interopRequireWildcard(require("../../common/event-utils"));function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || typeof obj !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}var _default =

{
  /**
   * Handle a11y for heading
   * https://ebay.gitbooks.io/mindpatterns/content/disclosure/tabs.html
   * @param {KeyboardEvent} event
   * @param {HTMLDivElement} el
   */
  handleHeadingKeydown(dataIndex, event) {
    eventUtils.handleActionKeydown(event, () => {
      event.preventDefault();
      this._setIndex(dataIndex);
    });

    eventUtils.handleArrowsKeydown(event, () => {
      event.preventDefault();

      var { input, state } = this;
      var len = input.tabs.length;
      var keyCode = event.charCode || event.keyCode;
      var direction = keyCode === 37 || keyCode === 38 ? -1 : 1;
      var selectedIndex = (state.selectedIndex + len + direction) % len;
      this.getEl("tabs-" + selectedIndex).focus();

      if (!input.activation || input.activation === 'auto') {
        this._setIndex(selectedIndex);
      }
    });
  },

  handleHeadingClick(selectedIndex) {
    this._setIndex(selectedIndex);
  },

  onCreate() {
    this.state = { selectedIndex: 0 };
  },

  onInput(input) {
    var { state } = this;
    input.tabs = input.tabs || [];
    input.panels = input.panels || [];

    if (!isNaN(input.selectedIndex)) {
      state.selectedIndex = parseInt(input.selectedIndex, 10) % (input.tabs.length || 1);
    }
  },

  onMount() {
    this._setupMakeup();
  },

  onUpdate() {
    this._setupMakeup();
  },

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  onDestroy() {
    this._cleanupMakeup();
  },

  _setIndex(selectedIndex) {
    var { state } = this;

    if (selectedIndex !== state.selectedIndex) {
      state.selectedIndex = selectedIndex;
      this.emit('select', { selectedIndex });
    }
  },

  _setupMakeup() {
    var { input, state } = this;

    if (!input.fake) {
      this._linearRovingTabindex = (0, _makeupRovingTabindex.createLinear)(this.getEl('tabs'), '.tabs__item', {
        index: state.selectedIndex,
        wrap: true
      });
    }
  },

  _cleanupMakeup() {
    if (this._rovingTabIndex) {
      this._rovingTabIndex.destroy();
      this._rovingTabIndex = undefined;
    }
  }
};exports.default = _default;module.exports = exports.default;